import { defineStore } from 'pinia'
import type { Ref } from 'vue'
import { createSuivi, Suivi } from '~/models/Suivi'
import { useMondayAPI } from '~/composables/mondayAPI'

export const useSuivi = defineStore('suivi', () => {
  const currentSuivi:Ref<null|Suivi> = ref(null)
  const suivis:Ref<{}> = ref({})
  const lots:Ref<null|Object> = ref(null)
  const mandat:Ref<null|Object> = ref(null)
  const loading:Ref<boolean> =  ref(false)
  const loadingList:Ref<boolean> =  ref(false)

  const refreshSuivi = async () => {
    const suivi = await useMondayAPI().requestItems([currentSuivi.value.id])
    useSuivi().currentSuivi = suivi.items[0]
  }

  const pageTitle = ref('Suivi de projets')

  return { currentSuivi, refreshSuivi, lots, mandat, suivis, loading, pageTitle, loadingList }
})
